import { Text as Paragraph, Title } from '../Typography';
import clsx from 'clsx';
import { CardImageNoMetaBall } from './components/CardImageNoMetaBall';
import { CardImageMetaBall } from './components/CardImageMetaBall';
import { CardButton } from './components/CardButton';
import { ImageTextCardType } from './types';

export const ImageTextCard = ({
  cardData,
  metaBall = false,
  buttonVariant = 'none',
}: ImageTextCardType) => {
  return (
    <section className="w-full p-0 flex flex-col relative">
      {!metaBall && <CardImageNoMetaBall asset={cardData?.image?.asset?.[0]} />}
      {metaBall && <CardImageMetaBall asset={cardData?.image?.asset?.[0]} />}
      <div className="text-center relative">
        {cardData?.subHeading && (
          <Paragraph
            tag="div"
            type="lead"
            className={clsx('mb-5 text-darkgray', metaBall ? 'mt-0' : 'mt-30')}
          >
            {cardData?.subHeading}
          </Paragraph>
        )}
        {cardData?.title && (
          <Title className="mb-5" tag="div" type="xs">
            {cardData?.title}
          </Title>
        )}
        {cardData?.description && (
          <Paragraph tag="p" type="md">
            {cardData?.description}
          </Paragraph>
        )}
        <CardButton cardData={cardData} buttonVariant={buttonVariant} />
      </div>
    </section>
  );
};
